export const PHONE_DISPLAY = "+91 87916 76104";
export const TEL_LINK = "tel:+918791676104";
export const WA_LINK =
  "https://wa.me/918791676104?text=Namaste%20Satyam%20Financial,%20mujhe%20loan%20ki%20jaankari%20chahiye";
export const ADDRESS =
  "3, Peelwa Garden, Moti Dongri Road, Adarsh Nagar, Jaipur, Rajasthan 302004, India";
export const MAPS_DIRECTIONS =
  "https://www.google.com/maps/search/?api=1&query=Peelwa+Garden,+Moti+Dongri+Road,+Adarsh+Nagar,+Jaipur+302004";
export const MAPS_EMBED =
  "https://maps.google.com/maps?q=Peelwa%20Garden%2C%20Moti%20Dongri%20Road%2C%20Adarsh%20Nagar%2C%20Jaipur%20302004&t=&z=15&ie=UTF8&iwloc=&output=embed";
export const OFFICE_HOURS = "Mon–Sat • 10:00 AM – 7:00 PM";
export const GOOGLE_REVIEW_LINK = MAPS_DIRECTIONS;

export const scrollToId = (e, id) => {
  e?.preventDefault?.();
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const LOANS = [
  {
    id: "home-loan",
    title: "Home Loan",
    tagline: "Apne khud ke ghar ka sapna, ab poora hone wala hai.",
    rate: "8.35%*",
    tenure: "30 saal tak",
    extra: "Tax benefits 80C & 24B",
    image:
      "https://images.unsplash.com/photo-1659352787906-f809a3b9e86e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBmYW1pbHklMjBob21lJTIwbG9hbiUyMGhhcHB5JTIwaG91c2UlMjBwdXJjaGFzZXxlbnwwfHx8fDE3ODk4Njg0MDd8MA&ixlib=rb-4.1.0&q=85",
    highlights: ["Doorstep document pickup", "Zero processing fee guidance", "Bank se direct sanction letter"],
  },
  {
    id: "business-loan",
    title: "Business Loan",
    tagline: "Vyapar ko nayi unchaiyon par le jaane ke liye fast capital.",
    rate: "11.50%*",
    tenure: "12–60 months",
    extra: "No collateral up to ₹30L*",
    image:
      "https://images.unsplash.com/photo-1758876204763-5b346b174d0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBidXNpbmVzcyUyMG93bmVyJTIwc2hvcCUyMGVudHJlcHJlbmV1ciUyMGZpbmFuY2V8ZW58MHx8fHwxNzg5ODY4NDA3fDA&ixlib=rb-4.1.0&q=85",
    highlights: ["Quick 48-hour approval", "Minimal GST & ITR paperwork", "Growth ke liye flexible capital"],
  },
  {
    id: "personal-loan",
    title: "Personal Loan",
    tagline: "Shaadi, medical emergency ya travel — instant funds, bina jhanjhat.",
    rate: "10.49%*",
    tenure: "12–72 months",
    extra: "Direct bank transfer",
    image:
      "https://images.unsplash.com/photo-1659352791239-6a796c124088?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBmYW1pbHklMjBob21lJTIwbG9hbiUyMGhhcHB5JTIwaG91c2UlMjBwdXJjaGFzZXxlbnwwfHx8fDE3ODk4Njg0MDd8MA&ixlib=rb-4.1.0&q=85",
    highlights: ["Fast eligibility check", "100% transparent charges", "Koi end-use restriction nahi"],
  },
  {
    id: "education-loan",
    title: "Education Loan",
    tagline: "Bachhe ke ujjwal bhavishya aur dream college admission ke liye.",
    rate: "9.15%*",
    tenure: "15 saal tak",
    extra: "India & study abroad",
    image:
      "https://images.unsplash.com/photo-1627556704290-2b1f5853ff78?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBzdHVkZW50JTIwdW5pdmVyc2l0eSUyMGdyYWR1YXRpb24lMjBlZHVjYXRpb24lMjBsb2FufGVufDB8fHx8MTc4OTg2ODQwN3ww&ixlib=rb-4.1.0&q=85",
    highlights: ["Tuition fees & living expenses cover", "Moratorium period available", "Simple documentation"],
  },
];

export const MARQUEE_ITEMS = [
  "HOME LOAN",
  "BUSINESS LOAN",
  "PERSONAL LOAN",
  "EDUCATION LOAN",
  "LOW INTEREST RATE*",
  "FAST 24–48HR APPROVAL",
  "ZERO HIDDEN CHARGES",
  "MINIMAL DOCUMENTATION",
];

export const FAQS = [
  {
    q: "Loan ke liye kaun kaun se documents chahiye?",
    a: "Basic documents jaise Aadhaar, PAN, bank statement aur income proof (salary slip ya ITR). Loan type ke hisaab se thode aur documents lag sakte hain — ek call par hum aapko poori list bata denge.",
  },
  {
    q: "Satyam Financial se loan lene mein kitna time lagta hai?",
    a: "Documents ready hone ke baad zyada tar cases mein 24–48 ghante mein approval mil jata hai. Humara process seedha aur fast hai — bina banks ki lambi lines ke.",
  },
  {
    q: "Mera CIBIL score kam hai, toh kya loan mil sakta hai?",
    a: "Kam score par bhi options ho sakte hain — co-applicant ya flexible lender options. Ek baar call kijiye, hum aapki profile dekh kar best guidance denge.",
  },
  {
    q: "Kya koi hidden processing fee ya extra charge hota hai?",
    a: "Bilkul nahi. Humara process 100% transparent hai — saare charges pehle hi clearly bata diye jaate hain. Zero hidden charges, humesha.",
  },
];

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Math.round(n));
